import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IServerResourceSampleVm } from '../server-resource-sample-vm.model';

@Injectable({ providedIn: 'root' })
export class AdminServerResourceSamplesService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AdminServerResourceSamples`;
  }

  get(hours: number): Observable<IServerResourceSampleVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (hours !== undefined && hours !== null) {
      params = params.set('hours', hours.toString());
    }
    return this.http.get<IServerResourceSampleVm[]>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
